(() => {
  const getDrawer = () => document.getElementById('CartDrawer');
  const getBackdrop = () => document.querySelector('[data-cart-drawer-backdrop]');

  function openDrawer() {
    const drawer = getDrawer();
    const backdrop = getBackdrop();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    const drawer = getDrawer();
    const backdrop = getBackdrop();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
  }

  function updateHeaderCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
    });
  }

  async function refreshDrawer() {
    const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!res.ok) return;
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newDrawer = doc.getElementById('CartDrawer');
    const newBackdrop = doc.querySelector('[data-cart-drawer-backdrop]');
    const oldDrawer = getDrawer();
    const oldBackdrop = getBackdrop();
    if (newDrawer && oldDrawer) {
      const wasOpen = oldDrawer.classList.contains('is-open');
      newDrawer.classList.toggle('is-open', wasOpen);
      newDrawer.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');
      if (wasOpen) {
        newDrawer.removeAttribute('inert');
      } else {
        newDrawer.setAttribute('inert', '');
      }
      oldDrawer.replaceWith(newDrawer);
      if (newBackdrop && oldBackdrop) {
        newBackdrop.classList.toggle('is-open', wasOpen);
        oldBackdrop.replaceWith(newBackdrop);
      }
    }
  }

  async function changeLineItem(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const cartData = await res.json();
    updateHeaderCartCount(cartData.item_count);
    await refreshDrawer();
  }

  async function clearCart() {
    const res = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: '',
    });
    const cartData = await res.json();
    updateHeaderCartCount(cartData.item_count);
    await refreshDrawer();
  }

  async function addToCart(form) {
    const formData = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => null);
      return { ok: false, error: err };
    }
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    updateHeaderCartCount(cart.item_count);
    await refreshDrawer();
    return { ok: true };
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-cart-drawer-toggle]');
    if (toggle) {
      event.preventDefault();
      openDrawer();
      return;
    }

    const closeBtn = event.target.closest('[data-cart-drawer-close]');
    if (closeBtn) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const backdrop = event.target.closest('[data-cart-drawer-backdrop]');
    if (backdrop) {
      closeDrawer();
      return;
    }

    const dec = event.target.closest('[data-cart-qty-decrease]');
    if (dec) {
      const item = dec.closest('[data-cart-item]');
      const key = item.dataset.key;
      const qtyEl = item.querySelector('[data-cart-qty]');
      const newQty = Math.max(0, parseInt(qtyEl.textContent, 10) - 1);
      changeLineItem(key, newQty);
      return;
    }

    const inc = event.target.closest('[data-cart-qty-increase]');
    if (inc) {
      const item = inc.closest('[data-cart-item]');
      const key = item.dataset.key;
      const qtyEl = item.querySelector('[data-cart-qty]');
      const newQty = parseInt(qtyEl.textContent, 10) + 1;
      changeLineItem(key, newQty);
      return;
    }

    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      const item = remove.closest('[data-cart-item]');
      const key = item.dataset.key;
      changeLineItem(key, 0);
      return;
    }

    const clear = event.target.closest('[data-cart-clear]');
    if (clear) {
      event.preventDefault();
      clearCart();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    const submitter = event.submitter;
    if (submitter && submitter.name === 'return_to') return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]:not([name="return_to"])');
    if (button) button.disabled = true;
    addToCart(form).then((result) => {
      if (button) button.disabled = false;
      if (result.ok) openDrawer();
    });
  });
})();
